import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faFacebook, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import {useHeroContentQuery} from './home-hero-content';
import { MailChimpSignup } from "../mailchimp-signup";
const HomeHero = () => {
    const data = useHeroContentQuery().contentfulPage;
        
    return <section className="section-about" style={{
        backgroundImage: `url(${data?.heroImage?.file.url})`,
    }}>
        <div className="section-about-container">
            <h1 className="section-about__heading">
                <span className="section-about__heading--main">{data?.heroHeading}</span>
                <span className="section-about__heading--sub">{data?.heroSubHeading}</span>
            </h1>
            <MailChimpSignup />
            <div className="section-about__socialMedia">
                <ul>
                    <li><a className="fa" href="https://www.facebook.com/be.evitat/?view_public_for=105639277979395"><FontAwesomeIcon icon={faFacebook} /></a></li>
                    <li><a href="https://www.instagram.com/be.evitat/" className="fa"><FontAwesomeIcon icon={faInstagram} /></a></li>
                    <li><a href="https://www.linkedin.com/company/evitat" className="fa"><FontAwesomeIcon icon={faLinkedin} /></a></li>
                </ul>
            </div>
        </div>
    </section>
}


export default HomeHero

